
import { Textbox } from "components/Textbox/Textbox";
import { PersonContact } from "pages/OfficeAutomation/BaseInformation/PeoplePage/types";
import { useEffect, useRef, useState } from "react";
import { convertAddress, trans, uuidv4 } from "utils/helpers";
import { ContactType } from "types/enum";
import { ModalForm } from "components/ModalForm/ModalForm";

import { Address } from "components/Address/Address";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { SelectBox } from "components/Select/Select";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { postCustomerPhoneListApi } from "./api";
import { Button } from "components/Button/Button";

interface PersonContactFormPropsType {
    customerPositionId?:any
    reset?:any
    onHide?:any
}
export const PhoneForm = ({customerPositionId,reset,onHide}: PersonContactFormPropsType) => {
  let data: any;
  //  const [contactType_, setContactType_] = useState(personContact?.ContactFixType || "Phone");
  const [resetForm, setResetForm] = useState(false);
  const [type, setType] = useState<any>(1);
const formRef=useRef<any>()
  const [save_Exit, setSave_Exit] = useState<boolean>(false);
  const [showMap, setShowMap] = useState<boolean>(false);
  const [personLocation, setpersonLocation] = useState<any>();

  const handlePersonContactFormSubmit = async (event) => {
    event.preventDefault();


    let Value:any = ""
    if(type == "4"){
        Value =JSON.stringify({
               Address: formRef.current?.Address?.value,
               Plaque: formRef.current?.Plaque?.value,
               Unit: formRef.current?.Unit?.value,
               Altitude: formRef.current?.Altitude?.value,
               Longitude: formRef?.current.Longitude?.value,
               Latitude: formRef?.current.Latitude?.value ,
               PostalCode: formRef?.current.PostalCode?.value,
             })
    }else{
        Value =  formRef.current?.value?.value
    }



    const data = {
      ContactType: +type,
      Description: formRef.current.Description.value,
      ExtraDescription:formRef.current.ExtraDescription.value,
      IsDefault: formRef.current.IsDefault.checked,
      Value: Value,
      PositionId:customerPositionId
    };
    try {
      const res = await postCustomerPhoneListApi(data);
      reset()
    onHide()
    } catch (error) {}

  };



  return (
    <div className="person-contact-form card">
      <div className="card-body">
        <div className="container-fluid">
          <form className="row " ref={formRef}>
            <div className="col-lg-3 mt-1">
              {/* <SelectBox
                lable="ContactType"
                selectType="select"
                //  mode={mode}
                required={true}
                name="ContactType"
                onChange={(e) => setType(e.target.value)}
                val={[ContactType.Phone, ContactType.Mobile]}
                value={ContactType.Phone}
                options={[trans(ContactType[1]), trans(ContactType[2])]}
              /> */}


                            <EnumerationTypeSelect
                             label="ContactType"
                             enumTypeSelect="ContactType"
                        
                             required={true} 
                             name="ContactType" 
                             Change={(e) =>{  
                              ;setType(e.ContactType)}}
                           
                             value={type} 
                            />
                     
            </div>
            {
                            {
                                1: (
                                    <div className="col-lg-3 mt-1">
                                        <Textbox
                                         
                                            required={true}
                                           
                                            textboxType="tel"
                                            textboxName="value"
                                            labelText="Phone"
                                            resetForm={resetForm}
                                            maxLength={15}
                                        />
                                    </div>
                                ),
                                2: (
                                    <div className="col-lg-3 mt-1">
                                        <Textbox
                                        required={true}
                                         
                                            textboxType="mobile"
                                            textboxName="value"
                                            labelText="mobile"
                                            resetForm={resetForm}
                                            //maxLength={11}
                                        />
                                    </div>
                                ),
                                3: (
                                    <div className="col-lg-3 mt-1">
                                        <Textbox
                                        required={true}
                                           
                                            textboxType="email"
                                            textboxName="value"
                                            labelText="email"
                                            resetForm={resetForm}
                                        />
                                    </div>
                                ),

                                4: (
                                    <>
                                        <Address/>
                                    </>
                                ),
                                5:(
                                <div className="col-lg-3 mt-1">
                                    <Textbox
                                        required={true}
                                      
                                        textboxType="tel"
                                        textboxName="value"
                                        labelText="Fax"
                                        resetForm={resetForm}
                                        maxLength={15}
                                    />
                                </div>
                                ),
                                6:(
                                <div className="col-lg-3 mt-1">
                                    <Textbox
                                        required={true}
                                     
                                        textboxType="tel"
                                        textboxName="value"
                                        labelText="Extension"
                                        resetForm={resetForm}
                                        maxLength={10}
                                    />
                                </div>
                                ),
                                7:(
                              <div className="col-3 mt-1">
                              <Textbox
                                        required={true}
                                      
                                            textboxType="text"
                                            textboxName="value"
                                            labelText="ECEOrganizationCode"
                                            resetForm={resetForm}
                                        />
                              </div>
                                ),
                                8: (
                                    <div className="col-3 mt-1">
   <Textbox
                                        required={true}
                                      
                                            textboxType="text"
                                            textboxName="value"
                                            labelText="description"
                                            resetForm={resetForm}
                                        />
                                    </div>
                                ),
                                9: (
                                    <div className="col-lg-3 mt-1">
                                        <Textbox
                                        required={true}
                                      
                                            textboxType="text"
                                            textboxName="value"
                                            labelText="ECEOrganizationCode"
                                            resetForm={resetForm}
                                        />
                                    </div>
                                ),

                            }[type]
                        }

<div className="w-100"></div>
            <div className="col-lg-6 mt-1">
              <Textbox
                textboxType="textarea"
                textboxName="Description"
                labelText="remarks"
                maxLength={900}
                resetForm={resetForm}
              />
            </div>
            <div className="col-lg-6 mt-1">
              <Textbox
                textboxName="ExtraDescription"
                textboxType="textarea"
                labelText={"ExtraDescription"}
              />
            </div>
            <div className="w-100"></div>
            <div className="col-md-4 col-sm-12">
              <CheckableButton
                labelText="IsDefault"
                type="checkbox"
                inputName="IsDefault"
              />
            </div>
            <div className="col-lg-12 mt-1 btns_form">
         
              {/* <Button btnType="cancel" value="Cancel" onClick={() => showPersonContactFormCallback(false)} /> */}
            </div>
          </form>
          <div className="d-flex justify-content-end">

          <Button
     btnType="submit"
     value={'save'}
            onClick={(e)=>handlePersonContactFormSubmit(e)}
              />
          </div>
        </div>
      </div>
    </div>
  );
};
